import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedEventGames: [],
  selectedEventId: null,
  currentSelectedEvent: null,
  selectedEventGames2: [],
  highlightSportTypeId: '',
  selectedPage: 0,
  totalPage: 1,
  groupedData: [],
  eventDetailCatch: {},
  selectedLeagueIdList: [],
  selectedCountryLeagueIdList: {},
  selectedCountryIdList: [],
  selectedCountryLeagueData: [],
};
export const eventSlice = createSlice({
  name: 'Event',
  initialState,
  reducers: {
    updateEventGames: (state, action) => {
      state.selectedEventGames = action.payload.selectedEventGames;
      state.selectedEventGames2 = action.payload.selectedEventGames2;
    },
    updateEvent: (state, action) => {
      state.totalPage = action.payload.totalPage;
      state.groupedData = action.payload.groupedData;
      state.highlightSportTypeId = action.payload.highlightSportTypeId;
    },
    updateEventDetailCatch: (state, action) => {
      state.eventDetailCatch = action.payload.eventDetailCatch;
    },
    updateEventPage: (state, action) => {
      state.selectedPage = action.payload.selectedPage;
    },
    updateSelectedleagueIdList: (state, action) => {
      state.selectedLeagueIdList = action.payload.selectedLeagueIdList;
    },
    updateSelectedCountryleagueIdList: (state, action) => {
      state.selectedCountryLeagueIdList =
        action.payload.selectedCountryLeagueIdList;
    },
    updateSelectedCountryIdList: (state, action) => {
      state.selectedCountryIdList = action.payload.selectedCountryIdList;
    },
    updateSelectedCountryLeagueData: (state, action) => {
      state.selectedCountryLeagueData =
        action.payload.selectedCountryLeagueData;
    },
    updateSelectedEventId: (state, action) => {
      state.selectedEventId = action.payload.selectedEventId;
    },
    updateCurrentSelectedEvent: (state, action) => {
      state.currentSelectedEvent = action.payload.currentSelectedEvent;
    },
  },
});
export const {
  updateEventGames,
  updateEvent,
  updateEventDetailCatch,
  updateEventPage,
  updateSelectedleagueIdList,
  updateSelectedCountryleagueIdList,
  updateSelectedCountryIdList,
  updateSelectedCountryLeagueData,
  updateSelectedEventId,
  updateCurrentSelectedEvent,
} = eventSlice.actions;
export default eventSlice.reducer;
